module.exports = __webpack_public_path__ + "img/hohlsaum_enzianblau_ral5010.e15207a6.jpg";